import React, { useContext, useState, useEffect } from 'react';
import { QuestionToAsk, PrintPage, ReturnToHome } from '../../components';
import { Button } from '@americanexpress/dls-react';
import userContext from '../../components/ContextComponent/UserContext';
import { CONSTANTS } from '../../constants';
import { AmazonCardOption } from '../../utils/AmazonPixel';
import { CallMetaPixelEvent } from '../../utils/MetaPixel';
import { CallIMOOnThankYouPage } from '../../utils/IMOPixel';
import { CallCriteoOnThankYouPage } from '../../utils/CriteoPixel';
import { CallTaboolaOnThankYouPage } from '../../utils/TaboolaPixel';
import { CallThinkResultOnThankYouPage } from '../../utils/ThinkResultPixel';
import { LinkedInEvent } from '../../utils/LinkedInPixel';

function GO2Pended({ apiOutput, data }) {
    const { formData } = useContext(userContext);
    const [isFraud, setFraud] = useState(false);
   
    useEffect(() => {
        CallIMOOnThankYouPage();
        CallCriteoOnThankYouPage();
        CallMetaPixelEvent();
        CallTaboolaOnThankYouPage();
        CallThinkResultOnThankYouPage();
        window.setITag("confirmation", "success", "23644");
        window.setPageContext("ThankYou");
        if (apiOutput.go2ApiDecisionReason === CONSTANTS.go2ApiDecision.fraudWN
            && apiOutput.fraudWNCode !== undefined
            && apiOutput.fraudWNCode !== null
            && CONSTANTS.fraudWNCode.codes.some(e => apiOutput.fraudWNCode.indexOf(e) >= 0)) {
            setFraud(true);
        }
    }, []);
    let vkycEnable = (apiOutput?.go2ApiDecision?.toLowerCase() === CONSTANTS.go2ApiDecision.pended.toLowerCase() && apiOutput.purpose?.toLowerCase() === CONSTANTS.go2ApiPurpose.vkyc.toLowerCase());
    const Pended = () => {
        return (<div className="pad-responsive">
            <div className="text-align-center pad-1">
                Thank you {formData.firstName}!
            </div>
            <div className="text-align-center pad-1">
                We have received your application{vkycEnable && <> and now need to verify your identity</>}
            </div>
            <div className="text-align-center pad-1">
                Application Reference No. {apiOutput?.go2ApiPcnNumber}
            </div>
            {!vkycEnable && <div className="text-align-center pad-1">
                Please note: You will be contacted by a representative of American Express to <br />
                collect the necessary documents.
            </div>}
            {/*{vkycEnable && (<><div></div>*/}
            {/*    <div className="text-align-center pad-1">*/}
            {/*        Please follow on the link below to complete your identify verification process through Video KYC.*/}
            {/*    </div></>)}*/}
            {/*{vkycEnable && <div className="text-align-center pad-1">*/}
            {/*    Video KYC only available during Monday-Sunday 9AM-9PM IST (Except <br />*/}
            {/*    National Holidays)*/}
            {/*</div>} */}
        </div>);
    }
    const PendedWithFraud = () => {
        return (<div className="pad-responsive">
            <div className="text-align-center pad-1">
                Thank you {formData?.firstName}! Your application is being processed.
            </div>
            <div className="text-align-center pad-1">
                Application Reference No. {apiOutput?.go2ApiPcnNumber}
            </div>
            <div className="text-align-center pad-1">
                We will review your application and contact you if we need additional information.
            </div>
        </div>);
    }
    const VideoKycButton = () => {
        return (<><div className="flex flex-column flex-align-items-center pad-responsive">
            <a href={apiOutput.idFyCaptureUrl}>
                <Button styleType="primary">Start Video KYC</Button>
            </a>
        </div>
            <div className="col-md-12 text-align-center pad-1 nav-link">
                <a className="nav-link" href='https://www.americanexpress.com/en-in/business/faq/video-kyc-faqs/' target='_blank'>
                    Video KYC Frequently Asked Questions
                </a>
            </div></>);
    }
    return (
        <div>
            <div className="stack body">
                {
                    (isFraud) ? <PendedWithFraud /> : <Pended />
                }
                <div className="pad-1">
                    {!vkycEnable && <ReturnToHome apiOutput={apiOutput} />}
                    {vkycEnable && <VideoKycButton />}
                    <PrintPage />
                    <QuestionToAsk />
                </div>
            </div>
            <img src="https://www.facebook.com/tr?id=333035019537250&ev=Lead" height="1" width="1" style={{ display: 'none' }} />
            <AmazonCardOption product={data?.selectedProduct} />
            <LinkedInEvent />
        </div>
    );
}
export default GO2Pended;